/**
 * External dependencies
 */
import { Component } from 'react'
import classnames from 'classnames'

import { range } from '~bookwormgb/util/range'

class ProductsListPlaceholder extends Component {

	render() {
		const {
			limit = 3,
			placeholder = 0,
			showImage = true,
			showProductFormat = true,
			showProductTitle = true,
			showProductAuthor = true,
			showProductPrice = true,
			showProductRating = true,
			showProductRatingCount = true,
			design = 'style-v1',
			mdColumns = 2,
			lgColumns = 2,
			columns = 2,
		} = this.props

		const output = (
			<div className={ classnames( [
					'products',
					'bookwormgb-products-list-placeholder-block'
				], { 
					'border-top border-left' : design === 'style-v1',
					'px-4 pt-4 border' : design === 'style-v3',
					[`row no-gutters row-cols-md-${mdColumns} row-cols-lg-${lgColumns} row-cols-xl-${columns}`] : design === 'style-v5',
				} ) }
			>
				{ range( 1, ( placeholder > 0 ? placeholder : limit ) + 1 ).map( i => {
					return(
						<div 
							className={ classnames( [ 'bookwormgb-products-list-placeholder' ], 
								{ 
									'border-right border-bottom' : design === 'style-v1',
									'p-3' : ( design !== 'style-v3' && design !== 'style-v5' && design !== 'style-v4' ),
									'mb-5' : design === 'style-v3',
									'border-top border-right border-left p-4d75' : design === 'style-v4',
									'border-bottom' : ( i === limit && design === 'style-v4' ),
									'col border-right border-bottom p-4' : design === 'style-v5',
									'rounded-md mb-5 border' : design === 'style-v6',
								} ) }
							key={ `product-${i}` }
						>
							<div className="media m-1">
								{ showImage &&
									<div className={ classnames( [ 'progress bg-light' ], { 'mb-2' : design !== 'style-v4' } ) } style={ design === 'style-v4' ? { width:'120px', height:'183px' }  : design === 'style-v1' ? { width:'70px', height:'107px' } : { width:'100px', height:'150px' } }></div>
								}
								<div className="media-body ml-3">
									{ ( ( design === 'style-v2' || design === 'style-v4' || design === 'style-v5' || design === 'style-v6' ) && showProductFormat ) &&
										<div className="badge badge-shadow w-50">
											<div className="progress bg-light"></div>
										</div>
									}
									{ showProductTitle &&
										<div className="badge badge-shadow w-80">
											<div className="progress bg-light"></div>
										</div>
									}
									{ ( ( design === 'style-v2' || design === 'style-v4' || design === 'style-v5' || design === 'style-v6' ) && showProductAuthor ) &&
										<div className="badge badge-shadow w-50 d-block">
											<div className="progress bg-light"></div>
										</div>
									}
									{ showProductPrice &&
										<div className="badge badge-shadow w-50">
											<div className="progress bg-light"></div>
										</div>
									}
									{ ( showProductRating && design === 'style-v4' ) &&
										<div className="d-flex align-items-center">
											<div className="badge badge-shadow" style={ { width:'100px' } }>
												<div className="progress bg-light"></div>
											</div>
											{ showProductRatingCount &&
												<div className="progress bg-light rounded-pill ml-2" style={ { width:'20px', height: '20px' } }></div>
											}
										</div>
									}
								</div>
							</div>
						</div>
					)
				} ) }
			</div>
		)

		return output
	}
}

export default ProductsListPlaceholder